import { roleColorClasses, roleLabel } from '../../utils/roleStyles';

interface UserEmailProps {
  email: string;
  role?: string | null;
  className?: string;
}

/**
 * Renders a user's email as a colour-coded pill keyed on their role so admins
 * can scan any table and instantly see what kind of user a row belongs to.
 * Colours come from the shared role palette (utils/roleStyles).
 */
export function UserEmail({ email, role, className }: UserEmailProps) {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-md text-xs font-medium ${roleColorClasses(role)} ${className ?? ''}`}
      title={role ? `${email} (${roleLabel(role)})` : email}
    >
      {email}
    </span>
  );
}
